const selectActiveInactiveOptions = [
  { id: true, name: 'Ativo' },
  { id: false, name: 'Inativo' },
];

export default selectActiveInactiveOptions;
